module.exports = __webpack_public_path__ + "img/navbar-3.0b1cea46.png";